import { useCallback, useState } from 'react'
import lodashIncludes from 'lodash/includes'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updatePlanSelection } from 'src/useCase/userTreatment'
import { getInfo } from 'src/useCase/user'
import { PATH as PATH_CHAT } from 'src/pages/chat/Chat'
import { useAppSelector } from 'src/store'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'

interface PlanSelectionOptions {
  planId?: string | number | null
  waitDoctorProposal?: boolean
}

export default function usePlanSelection(
  userTreatmentId?: string | number | null,
) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const userInfo = useAppSelector((state) => state.ui.app.authInfo)

  const handlePlanSelection = useCallback(
    async ({
      planId = null,
      waitDoctorProposal = false,
    }: PlanSelectionOptions) => {
      if (!userTreatmentId) return

      const treatment = userInfo?.user_treatments?.find(
        (t) => t.id === Number(userTreatmentId),
      )

      if (
        treatment &&
        !lodashIncludes(
          [
            USER_TREATMENT_STATE.AWAITING_PLAN,
            USER_TREATMENT_STATE.REGISTERED_INTERVIEW,
          ],
          treatment.state,
        )
      ) {
        return
      }
      try {
        setLoading(true)
        const payload: any = {
          id: userTreatmentId,
          has_selected_plan: !waitDoctorProposal,
        }

        if (planId !== null && planId !== undefined) {
          payload.plan_id = planId
        }

        await dispatch(updatePlanSelection(payload) as any)

        await dispatch(
          getInfo({
            with: 'userTreatments',
          }) as any,
        )

        if (waitDoctorProposal) {
          navigate(PATH_CHAT)
        }
      } finally {
        setLoading(false)
      }
    },
    [dispatch, userTreatmentId, navigate],
  )

  return { handlePlanSelection, loading }
}
